exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._17W9mWbqpEo62z8AGvx7Xk {\n  font-size: 16px;\n  margin-bottom: 0;\n}\n\n.t-awCdD60m8V0rAu4r0jD {\n  font-size: 12px;\n  margin-bottom: 0;\n}\n", ""]);

// exports
exports.locals = {
	"rowL1": "_17W9mWbqpEo62z8AGvx7Xk",
	"rowL2": "t-awCdD60m8V0rAu4r0jD"
};


//////////////////
// WEBPACK FOOTER
// /Users/smotley795/Source/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/smotley795/Source/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/Common/Table/CellRendererComponents/SplitTextRow/SplitTextRow.css
// module id = 10639
// module chunks = 23